<template>
  <div id="topBarBox" class="topBarBox clearfix">
    <div class="topbtns">
      <span
        class="topbtn notice"
        :class="{ newmsg: hasNotReaded, newIm: newImMsg }"
        @click="goNoticeView"
      ></span>
      <span class="topbtn set" @click="switchLang" v-if="userId"></span>
      <span class="topbtn logout" @click="exitLogin" v-if="userId"></span>
      <span class="login1  pointer " @click="toLogin" v-else>登录/注册</span>
    </div>
    <div class="topmenus">
      <div
        class="topmenu "
        @click="goCX"
        :class="[curMenu == 3 ? 'active' : '']"
      >
        畅学
      </div>
      <div
        class="topmenu studycenter"
        @click="goStudyCenter"
        :class="[curMenu == 1 ? 'active' : '']"
      >
        {{ $t("menu.studycenter") }}
      </div>

      <div class="topmenu mine" :class="[curMenu == 2 ? 'active' : '']">
        {{ $t("menu.mine") }}
        <ul class="topsubmenu">
          <li
            v-for="(item, index) in subMenu"
            :key="index"
            @click="gotoMenu(item.link)"
          >
            {{ item.menu }}
          </li>
        </ul>
      </div>
    </div>
    <imChatWin ref="imChatWin" v-if="userId"></imChatWin>
  </div>
</template>
<script>
// import WisConfirm from "@/components/common/wisConfirm.vue";
import imChatWin from "@/components/common/imChatWin.vue";
import { mapMutations } from "vuex";
export default {
  components: {
    // WisConfirm
    imChatWin
  },
  data: function() {
    return {
      // subMenu: [
      //   { menu: this.$t("menu.accountSettings"), link: "accountSettings" },
      //   { menu: this.$t("menu.endedCourse"), link: "endedCourse" },
      //   // { menu: "我的订单", link: "" },
      //   // { menu: "我参与的", link: "" },
      //   // { menu: "我的优惠券", link: "" },
      //   { menu: this.$t("menu.notice"), link: "notice" },
      //   { menu: this.$t("myJoin.myJoin"), link: "myJoin" }
      //   // { menu: "技术帮助", link: "" },
      //   // { menu: "投诉建议", link: "" },
      //   // { menu: "其他设置", link: "" }
      // ],
      lang: localStorage.getItem("lang"),
      newImMsg: false, // 是否有新消息
      language: this.$store.state.common.lang,
      userId: localStorage.getItem("userId")
    };
  },
  created() {
    this.$root.Bus.$on("newImMeg", v => {
      console.log("newImMeg", v);
      if (v && this.$route.name != "notice") {
        setTimeout(() => {
          this.newImMsg = true;
        }, 5);
      }
    });
  },
  beforeDestroy() {
    this.$root.Bus.$off("newImMeg");
  },
  mounted() {},
  computed: {
    subMenu() {
      return [
        { menu: this.$t("menu.accountSettings"), link: "accountSettings" },
        { menu: this.$t("menu.endedCourse"), link: "endedCourse" },
        // { menu: "我的订单", link: "" },
        // { menu: "我参与的", link: "" },
        // { menu: "我的优惠券", link: "" },
        { menu: this.$t("menu.notice"), link: "notice" },
        { menu: this.$t("myJoin.myExam"), link: "myExam" },
        { menu: this.$t("msg.category6"), link: "follow" }
        // { menu: "技术帮助", link: "" },
        // { menu: "投诉建议", link: "" },
        // { menu: "其他设置", link: "" }
      ];
    },
    curMenu() {
      return this.$store.state.common.curMenu;
    },
    noReadMsgList() {
      return this.$store.state.common.noReadMsgList;
    },
    hasNotReaded() {
      // 读取缓存是否有未读
      let notRead = false;
      let categoryList = [
        "SKTZ",
        "ZYTZ",
        "PJTZ",
        "KSTZ",
        "DKTZ",
        "HDTZ",
        "XSTZ",
        "YXTZ",
        "QTTZ"
      ];
      categoryList.forEach(item => {
        if (this.noReadMsgList[item] > 0) {
          notRead = true;
          return notRead;
        }
      });
      return notRead;
    }
  },
  methods: {
    switchLang() {
      this.$store.dispatch("common/changeLanguageDialogVisible", true);
      //  切换语言
      // this.$confirm(
      //   `${this.$t("lang.changeLanguage")}`,
      //   `${this.$t("common.titleTips")}`,
      //   {
      //     confirmButtonText: `${this.$t("common.confirm")}`,
      //     cancelButtonText: `${this.$t("common.cancel")}`,
      //     cancelButtonClass: "cancel",
      //     confirmButtonClass: "confirm",
      //     customClass: "webstu-msgbox",
      //     dangerouslyUseHTMLString: true
      //   }
      // )
      //   .then(() => {
      //     // on confirm
      //     let toLang = this.$i18n.locale == "zh" ? "en" : (this.$i18n.locale == "en" ? "tw": "zh")
      //     let changeLang = toLang;
      //     this.CHANGELANG(changeLang);
      //     this.$i18n.locale = changeLang;
      //     document.title = this.$t("common.documentTitle");
      //   })
      //   .catch(() => {
      //     // on cancel
      //   });
    },
    goNoticeView() {
			if (this.userId) {
			  this.newImMsg = false;
			  this.$router.push({
			    path: "/my/notice"
			  });
			} else {
				if(this.$route.path=='/learning/index'){
					localStorage.setItem('locationReash',1)
					window.location.reload();
				}else{
					localStorage.setItem('locationReash',1)
					this.$router.replace({ path: "/learning/index" });
				}
			 
			}
			
      
    },
    toLogin() {
      this.$emit("loginDialog", true);
    },
    exitLogin() {
      // let loginForm = localStorage.getItem("loginForm");

      localStorage.clear();
      sessionStorage.clear();
      // if (loginForm) {
      //   localStorage.setItem("loginForm", loginForm);
      // }
			window.location.href = `${
			  this.WITSBOX_ENV_PARAM.loginPage
			}#/learning/index`;
			window.location.reload();
			
      // this.$router.replace({
      //   path: "/user/login"
      // });
    },
    goStudyCenter() {
      if (this.userId) {
        this.$router.push({ path: "/study/center" });
      } else {
				if(this.$route.path=='/learning/index'){
					localStorage.setItem('locationReash',1)
					window.location.reload();
				}else{
					localStorage.setItem('locationReash',1)
					this.$router.replace({ path: "/learning/index" });
				}
       
      }
    },
    goCX() {
      this.$router.push({
        path: `/learning/index`
      });
    },
    gotoMenu(ele) {
      if (!ele) {
        return;
      }
      if (this.userId) {
        if (ele == "follow") {
          this.$router.push({
            path: `/follow/list`
          });
        } else {
          this.$router.push({
            path: `/my/${ele}`
          });
        }
      } else {
				if(this.$route.path=='/learning/index'){
					localStorage.setItem('locationReash',1)
			
				}else{
					localStorage.setItem('locationReash',1)
					this.$router.replace({ path: "/learning/index" });
				}
        
      }
    },
    ...mapMutations("common", ["CHANGELANG"])
  }
};
</script>
<style>
@keyframes newIm {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}</style
><style scoped lang="scss">
.login1 {
  color: rgba(255, 255, 255, 0.7);
  font-size: 16px;
  height: 30px;
  display: block;
  float: left;
  line-height: 30px;
  padding: 0 30px;
  border-left: 1px solid rgba(255, 255, 255, 0.6);
}

#topBarBox {
  position: relative;
  z-index: 10;
  width: 100%;
  height: 60px;
  line-height: 60px;
  background: url(../assets/images/common/logo.png) no-repeat 20px center,
    linear-gradient(-234deg, #29418a 0%, #0f2770 100%);
}
.topbtns {
  float: right;
  margin-top: 15px;
  .topbtn {
    width: 80px;
    height: 30px;
    display: block;
    float: left;
    cursor: pointer;
    position: relative;
    border-left: 1px solid rgba(255, 255, 255, 0.6);
    &::before {
      content: "";
      display: block;
      width: 30px;
      height: 30px;
      margin: 0 auto;
      background: no-repeat center center / 100% 100%;
    }
    &.logout {
      width: 65px;
      &::before {
        background-image: url("../assets/images/icons/logout.svg");
      }
    }
    &.set::before {
      background-image: url("../assets/images/icons/set.svg");
    }
    &.notice {
      &::before {
        background-image: url("../assets/images/icons/notice.svg");
      }
      &.newmsg::before {
        background-image: url("../assets/images/icons/notice1.svg");
      }
      &.newIm::before {
        animation: newIm linear 1.5s infinite;
      }
    }
  }
}
.topmenus {
  float: right;
  margin-right: 20px;
  .topmenu {
    width: 120px;
    color: rgba(255, 255, 255, 0.7);
    text-align: center;
    float: left;
    white-space: nowrap;
    font-size: 16px;
    position: relative;
    cursor: pointer;
    transition: font 0.5s;
    // &.studycenter {
    //   width: 240px;
    // }
    &.mine:hover {
      .topsubmenu {
        display: block;
      }
    }
    &.active {
      color: #fff;
      font-size: 18px;
      &::after {
        content: "";
        display: block;
        width: 36px;
        height: 1px;
        position: absolute;
        bottom: 8px;
        left: 50%;
        margin-left: -18px;
        background: #fff;
      }
    }
  }
}
.topsubmenu {
  z-index: 30;
  display: none;
  margin: 0;
  padding: 0;
  position: absolute;
  top: 100%;
  width: 100px;
  overflow: hidden;
  border-radius: 0 0 6px 6px;
  background: #b8c3e3;
  left: 50%;
  margin-left: -50px;
  list-style: none;
  li {
    margin: 0;
    padding: 0;
    display: block;
    cursor: pointer;
    height: 35px;
    line-height: 35px;
    text-align: center;
    font-size: 14px;
    border-bottom: 1px solid #d2d9ee;
    color: #333;
    &:last-child {
      border-bottom: none;
    }
    &:hover {
      color: #fff;
      background: #6d7cac;
    }
  }
}
.en {
  .topsubmenu {
    width: 130px;
    margin-left: -65px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TopBar.vue